// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyClq6-1Caggz4JzXYNQPOsRHswoFyT3a4M",
  authDomain: "megaloto-express.firebaseapp.com",
  projectId: "megaloto-express",
  storageBucket: "megaloto-express.appspot.com",
  messagingSenderId: "582557788031",
  appId: "1:582557788031:web:dc58b4da64830f1dd81c4a",
  measurementId: "G-LD6HLDJZ9P"
};

// Initialize Firebase
export const appFirebase = initializeApp(firebaseConfig);
const analytics = getAnalytics(appFirebase);
export const messaging = getMessaging(appFirebase)